import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_CHANGE_COLLECTION_ACCOUNT: MijnRoute = {
    path: 'hypotheken-incassorekening',
    navigationEvent: 'toHypothekenIncassorekening',
    regex: /^\/hypotheek\/hypotheken-incassorekening$/,
    webcomponent: 'mijn-hypotheken-incassorekening-webcomponent'
};
